<template>
    <div class="g-ys">
        <modal :large="true" :show.sync="isDisplayed">
            <div class="modal-header" slot="modal-header">
                <h4>Validation du contrat</h4>
            </div>

            <div class="modal-body g-ys-modal-body" slot="modal-body">
                <div class="g-ys-iframe-viewport">
                    <iframe
                        :src="`${url}&disable_domain_validation=true`"
                        referrerpolicy="strict-origin-when-cross-origin"
                        v-if="displayState === 'iframe' && url && isDisplayed"
                    ></iframe>

                    <div
                        class="g-ys-loader"
                        v-if="displayState === 'loading'"
                    >
                        <loader></loader>
                        <div class="g-ys-loader-text">
                            En attente de la réponse de YouSign...
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer" slot="modal-footer"></div>
        </modal>
    </div>
</template>

<style lang="less">
@body-height: ~"calc(100vh - 300px)";

.modal-body.g-ys-modal-body {
    max-height: none;
}

.g-ys {
    &-iframe-viewport {
        height: @body-height;

        iframe {
            width: 100%;
            height: 100%;
            border: none;
        }
    }

    &-loader {
        text-align: center;
        margin-top: 50px;
    }
}
</style>

<script>
import Modal from 'vue-strap/src/Modal';
import Loader from '../Loader';
import {getOperation} from '../../api/operations';
import {sleep} from '../../utils';
import {manager} from '../../messages';

export default {
    components: {
        Loader,
        Modal
    },

    props: {
        /**
         * Reference to the operation object on which we are working, which
         * will get updated with the output of the API
         */
        operation: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            /**
             * When it turns to false, async retry operations will stop. This
             * allows to tear down retries when the component is destroyed.
             */
            run: true,

            /**
             * Indicates if the modal is displayed
             */
            isDisplayed: false,

            /**
             * URL of the YouSign iframe
             */
            url: null,

            /**
             * Current display state
             *
             * - none = nothing is displayed
             * - iframe = the YouSign iframe is displayed
             * - loading = the loading message is displayed
             */
            displayState: 'none'
        };
    },

    methods: {
        /**
         * Triggers the display of the modal in the initial state
         */
        display(url) {
            this.isDisplayed = true;
            this.displayState = 'iframe';
            this.url = url;
        },

        /**
         * Receives messages from the iframe. A lot of bullshit events could
         * be received but we only respond to the two we know.
         */
        onFinish({data: {event}}) {
            if (event === 'success' || event === 'cancel') {
                this.waitUntilDone();
            }
        },

        /**
         * Once YouSign has finished its things and we've received the
         * message from the iframe, we display a loader and wait for the
         * signed documents to appear in the operation. In order to do that,
         * we just check the operation in the API every second until it looks
         * good.
         *
         * (Looks good = either we have the signed URLs, either the operation
         * was canceled).
         */
        async waitUntilDone() {
            this.displayState = 'loading';

            for (let i = 0; i < 1000 && this.isDisplayed && this.run; i += 1) {
                const op = await getOperation({operation: this.operation.id});

                const notPendingAnymore = op.state !== 'PENDING';
                const hasSignedUrls = (
                    op.documents_to_sign.every(d => d.urls_signed)
                );

                if (notPendingAnymore || hasSignedUrls) {
                    manager.push(
                        'Succès.',
                        'Opération prise en compte par YouSign',
                        'success'
                    );
                    Object.assign(this.operation, op);
                    break;
                }

                await sleep(1000);
            }

            this.isDisplayed = false;
            this.displayState = 'none';
        }
    },

    /**
     * On component setup, listen for messages from the iframe
     */
    ready() {
        window.addEventListener('message', this.onFinish);
    },

    /**
     * On component shutdown, remove the listener
     */
    beforeDestroy() {
        window.removeEventListener('message', this.onFinish);
        this.run = false;
    }
};
</script>



// WEBPACK FOOTER //
// YousignModal.vue?22198aac